import axios from 'axios';
import { CONFIG_SERVER } from '../constants/common.constant';

const {
  CLIENT_ID,
  AUTH_URL,
  BACKEND_URL,
  REALM_ID,
} = CONFIG_SERVER;

export const getAuthUrl = () => {
  const realmId = REALM_ID;
  const url =
    AUTH_URL + `/auth/realms/${realmId}/protocol/openid-connect/token`;

  return url;
};

export const refreshToken = (refreshToken = '') => {
  let requestBody = new URLSearchParams();
  requestBody.append('grant_type', 'refresh_token');
  requestBody.append('client_id', CLIENT_ID);
  requestBody.append('refresh_token', refreshToken);
  requestBody.append('redirect_uri', window.location.origin);
  const realmId = REALM_ID;

  return axios({
    method: 'post',
    url: AUTH_URL + `/auth/realms/${realmId}/protocol/openid-connect/token`,
    data: requestBody,
  });
};

export const fetchTokenFromCode = (code = '', sessionState = '') => {
  let requestBody = new URLSearchParams();
  requestBody.append('grant_type', 'authorization_code');
  requestBody.append('client_id', CLIENT_ID);
  requestBody.append('code', code);
  requestBody.append('session_state', sessionState);
  requestBody.append('redirect_uri', window.location.origin);

  return axios({
    method: 'post',
    url: getAuthUrl(),
    data: requestBody,
  });
};

export const getTenantSetting = async () => {
  const res = await axios({
    method: 'GET',
    url: BACKEND_URL + '/backend/tenant/setting',
    // headers: {
    //   'X-TENANT-ID': 'local',
    // },
  });

  return res;
};

export const fetchPermissionToken = token => {
  let requestBody = new URLSearchParams();
  requestBody.append(
    'grant_type',
    'urn:ietf:params:oauth:grant-type:uma-ticket'
  );
  requestBody.append('audience', 'vindr-api');

  return axios({
    url: getAuthUrl(),
    method: 'post',
    data: requestBody,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
